import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { RecategorizeQueueRequest } from 'domain/usecases';
import { RemoteRecategorizeQueueRequest } from 'data/usecases/queue/remote-recategorize-queue-request';

export const makeRemoteRecategorizeQueueRequest = (requestId: string): RecategorizeQueueRequest => {
  return new RemoteRecategorizeQueueRequest(
    makeApiUrl(`/queue/requests/${requestId}/recategorize`),
    makeAuthorizeHttpClientDecorator()
  );
};
